import { t } from "@lingui/macro";
import { Eye, ChartLine, SidebarSimple, Briefcase } from "@phosphor-icons/react";
import { Button, Tabs, TabsList, TabsTrigger } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

import { useBuilderStore } from "@/client/stores/builder";
import { useViewStore, ViewTypes } from "@/client/stores/view";
import { useAnalysisContext } from "@/client/contexts/analysis-context";

export const BuilderHeader = () => {
  const activeView = useViewStore((state) => state.activeView);
  const setActiveView = useViewStore((state) => state.setActiveView);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore((state) => state.panel.left.handle.isDragging);
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);

  // Get optimization status from analysis context
  const { isSubscribed, isOptimizing, optimizationStatus, isLoadingOptimization, isGeneratingQuestions } = useAnalysisContext();

  // Determine if optimization is in progress
  const isOptimizationInProgress = 
    isLoadingOptimization ||
    isOptimizing ||
    isGeneratingQuestions ||
    isSubscribed ||
    optimizationStatus?.isInProgress;

  const onToggle = (side: "left" | "right") => {
    toggle(side);
  };

  return (
    <div
      style={{ left: `${leftPanelSize}%`, right: `0%` }}
      className={cn(
        "fixed inset-x-0 top-0 z-[20] h-16 lg:z-20",
        !isDragging && "transition-[left,right]",
      )}
    >
      <div className="flex h-full items-center justify-between px-4">
        <Button
          size="icon"
          variant="ghost"
          className="flex lg:hidden"
          onClick={() => {
            onToggle("left");
          }}
        >
          <SidebarSimple />
        </Button>

        <div className="flex items-center justify-center lg:mx-auto">
          <Tabs
            value={activeView}
            className=""
            onValueChange={(value) => setActiveView(value as ViewTypes)}
          >
            <TabsList className="bg-secondary-accent/50 flex h-10 w-full gap-x-1 rounded-lg p-1 backdrop-blur-md">
              <TabsTrigger
                value="builder"
                className="data-[state=active]:bg-primary data-[state=active]:text-background hover:bg-background/50 group flex-1 cursor-pointer rounded-md transition-colors duration-200 data-[state=active]:shadow-sm"
              >
                <div className="flex items-center gap-x-2">
                  <Eye className="h-5 w-5 transition-transform duration-200 group-hover:scale-110" />
                  <span className="text-sm font-medium">{t`Preview`}</span>
                </div>
              </TabsTrigger>
              <TabsTrigger
                value="analytics"
                className="data-[state=active]:bg-primary data-[state=active]:text-background hover:bg-background/50 group flex-1 cursor-pointer rounded-md transition-colors duration-200 data-[state=active]:shadow-sm"
              >
                <div className="relative flex items-center gap-x-2">
                  <ChartLine className="h-5 w-5 transition-transform duration-200 group-hover:scale-110" />
                  <span className="text-sm font-medium">{t`Analysis`}</span>
                  {isOptimizationInProgress && (
                    <div className="absolute -top-2 -right-5 h-3 w-3 animate-pulse rounded-full bg-red-500" />
                  )}
                </div>
              </TabsTrigger>
              <TabsTrigger
                value="job-description"
                className="data-[state=active]:bg-primary data-[state=active]:text-background hover:bg-background/50 group flex-1 cursor-pointer rounded-md transition-colors duration-200 data-[state=active]:shadow-sm"
              >
                <div className="flex items-center gap-x-2">
                  <Briefcase className="h-5 w-5 transition-transform duration-200 group-hover:scale-110" />
                  <span className="text-sm font-medium">{t`Job Posting`}</span>
                </div>
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>

        {/*<Button*/}
        {/*  size="icon"*/}
        {/*  variant="ghost"*/}
        {/*  className="flex lg:hidden"*/}
        {/*  onClick={() => {*/}
        {/*    onToggle("right");*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <SidebarSimple className="-scale-x-100" />*/}
        {/*</Button>*/}
      </div>
    </div>
  );
};
